import React, { Component } from 'react'
import NeedHelp from '../Elements/NeedHelp';
import { Tab, Tabs } from "react-bootstrap";
import VkTab from './vkTab';
import { getInitialRoute } from '../../../../../../utils';

export default class vkontaktefeed extends Component {
    render() {
        const { feedInfo } = this.props
        return (
            <div className="form-body create_feed_wt">
                <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details createFeedInsta personalizePopup">
                    <Tabs defaultActiveKey="Hashtag" id="VkontaktefeedTab" className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3">
                        {feedInfo && feedInfo.length && feedInfo[0].networkTab && feedInfo[0].networkTab.length ? feedInfo[0].networkTab.map(filter =>
                            <Tab eventKey={filter.feedtype} key={filter.filter} className="nav-link className= p-0" title={<span>{filter.feedName}</span>}>
                                <VkTab tab={filter.feedtype} />
                            </Tab>
                        ) : null}
                    </Tabs>
                </div>
                <div className="form-actions w-100">
                    <div className="f-between flex-wrap border-top pt-3 mt-4">
                        {getInitialRoute() === 'widget' ? 
                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/497245578'} supportLink={'https://taggbox.com/support/how-to-add-feeds-to-taggbox-widget/'} />
                        :
                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://vimeo.com/654879526'} supportLink={''} />
                        }
                        <div className="hideforBSearch">
                            <button type="button" className="btn btn-secondary">Back</button>
                            <span className="create_feed_hideshow">
                                <button type="button" className="commanBtn submit_create_feed btn btn-primary ms-4 " id="create_feed">
                                    Create Feed
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
